/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegacyTournamentGroupCreateRequest
 */
export interface LegacyTournamentGroupCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroupCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroupCreateRequest
     */
    bracket?: string;
}

/**
 * Check if a given object implements the LegacyTournamentGroupCreateRequest interface.
 */
export function instanceOfLegacyTournamentGroupCreateRequest(value: object): value is LegacyTournamentGroupCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function LegacyTournamentGroupCreateRequestFromJSON(json: any): LegacyTournamentGroupCreateRequest {
    return LegacyTournamentGroupCreateRequestFromJSONTyped(json, false);
}

export function LegacyTournamentGroupCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegacyTournamentGroupCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'bracket': json['bracket'] == null ? undefined : json['bracket'],
    };
}

export function LegacyTournamentGroupCreateRequestToJSON(json: any): LegacyTournamentGroupCreateRequest {
    return LegacyTournamentGroupCreateRequestToJSONTyped(json, false);
}

export function LegacyTournamentGroupCreateRequestToJSONTyped(value?: LegacyTournamentGroupCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'bracket': value['bracket'],
    };
}

